import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Link,
    Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import { publish } from 'pubsub-js';
import styles from './style';

/**
 * @name HelpServicesMobile
 * @param {*} props - react props
 * @returns {JSX.Element} - Renders Help centre services Accordion in mobile view
 */
const HelpServicesMobile = props => {
    const classes = styles();
    return (
        <Box className={classes.accordionBox}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon className='help-expand-icon' />}
                    aria-controls='panel1a-content'
                    id='panel1a-header'
                >
                    <Box component='img' src={props?.icon} className={classes.mobileIcon} />
                    <Typography variant='h6' className='accordion-title'>
                        {props?.title}
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    {props?.links.map(link => (
                        <Box className={classes.accordionDetails}>
                            <Link
                                href={link?.url}
                                className='link'
                                onClick={() => {
                                    publish(link?.action);
                                }}
                            >
                                <Typography variant='body2'>{link?.name}</Typography>
                            </Link>
                        </Box>
                    ))}
                </AccordionDetails>
            </Accordion>
        </Box>
    );
};

export default HelpServicesMobile;
